<template>
  <div class="card shadow mb-4">
    <div v-if="fastRenegociacaoLoading" class="col-12 text-center">
      Carregando...
    </div>
    <div v-else>
      <div class="card-header py-3">
        <h1>Renegociação - Invoice #{{ dados_renegociacao.id_invoice }}</h1>
      </div>
      <div>
        <div class="p-3">
          <div class="d-flex align-items-center">
            <h4 class="mx-1">Documentos da renegociação:</h4>
            <h5 class="mx-1">
              (Gerado por
              {{ fastTesourariaRenegociacao.usuarioGerou }})
            </h5>
          </div>
          <table class="table col-12">
            <thead>
              <tr>
                <th class="text-center">Tarefa</th>
                <th class="text-center">Status</th>
                <th class="text-center">Ação</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-center">Gerar nova cobrança</td>
                <td class="text-center text-success">Finalizado</td>
                <td class="text-center">
                  <button class="btn btn-success" @click="showModal('modalAcessarParcelas')">
                    Acessar parcelas
                  </button>
                </td>
              </tr>
              <tr>
                <td class="text-center">Envio do comprovante de pagamento</td>
                <td v-if="
                  !fastTesourariaRenegociacao.statusDocumentos.pagamento
                    .statusComprovante
                " class="text-center text-danger">
                  Pendente
                </td>
                <td v-else class="text-center text-success">Finalizado</td>
                <td v-if="
                  !fastTesourariaRenegociacao.statusDocumentos.pagamento
                    .statusComprovante
                " class="text-center">
                  <button class="btn btn-danger blink_me" @click="showModal('modalEnviarComprovante')">
                    Enviar
                  </button>
                </td>
                <td v-else class="text-center">
                  <a :href="dados_renegociacao.path_comprovante_pagamento" target="_blank">
                    <button class="btn btn-success">Visualizar</button>
                  </a>
                </td>
              </tr>
              <tr>
                <td class="text-center">Geração do contrato</td>
                <td v-if="
                  !fastTesourariaRenegociacao.statusDocumentos.contrato.gerado
                " class="text-center text-danger">
                  Pendente
                </td>
                <td v-else class="text-center text-success">Finalizado</td>
                <td v-if="
                  !fastTesourariaRenegociacao.statusDocumentos.pagamento
                    .statusComprovante
                " class="text-center">
                  <button class="btn btn-secondary" disabled>
                    Aguardando comprovante
                  </button>
                </td>
                <td v-else-if="
                  !fastTesourariaRenegociacao.statusDocumentos.contrato.gerado
                " class="text-center">
                  <button class="btn btn-danger blink_me" @click="showModal('modalGerarContrato')">
                    Gerar
                  </button>
                </td>
                <td v-else class="text-center">
                  <button class="btn btn-success" disabled>
                    Contrato gerado
                  </button>
                </td>
              </tr>
              <tr>
                <td class="text-center">Assinatura do contrato</td>
                <td v-if="
                  !fastTesourariaRenegociacao.statusDocumentos.contrato
                    .assinado
                " class="text-center text-danger">
                  Pendente
                </td>
                <td v-else class="text-center text-success">Finalizado</td>
                <td v-if="
                  !fastTesourariaRenegociacao.statusDocumentos.contrato.gerado
                " class="text-center">
                  <button class="btn btn-secondary" disabled>
                    Aguardando contrato
                  </button>
                </td>
                <td v-else class="text-center">
                  <button v-if="
                    fastTesourariaRenegociacao.statusDocumentos.contrato
                      .assinado
                  " class="btn btn-success" @click="showModal('modalVisualizarContrato')">
                    Visualizar
                  </button>
                  <button v-else class="btn btn-primary" @click="showModal('modalVisualizarContrato')">
                    Visualizar
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- MODALS -->
    <modal name="modalAcessarParcelas" :scrollable="true" height="auto" :shift-y="0.1" :focus-trap="true"
      :adaptive="true" :width="modalWidthLg">
      <div class="row p-4">
        <div class="col-9 pl-4 pr-4">
          <h4>Enviar comprovante de pagamento</h4>
        </div>
        <div class="col-3 pl-4 pr-4 text-right">
          <a class="btn btn-secondary" href="#" @click.prevent="hideModal('modalAcessarParcelas')">
            <b-icon-arrow-return-left />
          </a>
        </div>
      </div>
      <div class="p-4 text-center">
        <table class="table table-striped border border-dark">
          <thead class="thead-dark">
            <tr>
              <th class="text-center">Parcela</th>
              <th class="text-center">Valor</th>
              <th class="text-center">Data Vencimento</th>
              <th class="text-center">Status</th>
              <th class="text-center">Link de cobrança</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="e in fastTesourariaRenegociacao.parcelaRenegociacao
              .parcelasRenegociadas" :key="e.parcela">
              <td class="text-nowrap text-center align-items-center">
                {{ e.parcela }}
              </td>
              <td class="text-nowrap text-center">
                {{
                  e.valor_parcela.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </td>
              <td class="text-nowrap text-center">
                {{ new Date(e.data_vencimento).toLocaleDateString("pt-BR") }}
              </td>
              <td class="text-nowrap text-center">
                <strong v-if="e.cancelado" class="text-danger">Cancelado</strong>
                <strong v-else-if="e.estornado" class="text-success">Estornado</strong>
                <strong v-else-if="e.pago" class="text-success">Pago</strong>
                <strong v-else-if="e.vencido" class="text-danger">Vencido</strong>
                <strong v-else>Pendente</strong>
              </td>
              <td class="text-nowrap text-center p-1">
                <a :href="e.path_boleto" target="_blank" class="btn btn-primary text-white">
                  <small> Acessar parcela {{ e.parcela }} </small>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </modal>
    <modal name="modalEnviarComprovante" :scrollable="true" height="auto" :shift-y="0.1" :focus-trap="true"
      :adaptive="true" :width="modalWidthMd">
      <div class="row p-4">
        <div class="col-9 pl-4 pr-4">
          <h4>Enviar comprovante de pagamento</h4>
        </div>
        <div class="col-3 pl-4 pr-4 text-right">
          <a class="btn btn-secondary" href="#" @click.prevent="hideModal('modalEnviarComprovante')">
            <b-icon-arrow-return-left />
          </a>
        </div>
      </div>
      <div class="p-4 text-center">
        <uploader :file-status-text="statusText" :options="optionsArquivo" class="uploader-example"
          @file-success="fileSuccess" @file-added="fileValidation(dados_renegociacao.id_invoice, 1)">
          <uploader-unsupport />
          <uploader-drop>
            <p class="aluno_font_color">
              Arraste um comprovante de pagamento aqui ou
            </p>
            <uploader-btn :attrs="restrictArquivo">
              Clique aqui para selecionar um comprovante de pagamento
            </uploader-btn>
          </uploader-drop>
          <uploader-list />
        </uploader>
      </div>
    </modal>
    <modal name="modalGerarContrato" :shift-y="0.1" :focus-trap="true" :adaptive="true" :width="modalWidthLg">
      <div class="row p-4">
        <div class="col-9 pl-4 pr-4">
          <h4>Gerar contrato de renegociação</h4>
        </div>
        <div class="col-3 pl-4 pr-4 text-right">
          <a class="btn btn-secondary" href="#" @click.prevent="hideModal('modalGerarContrato')">
            <b-icon-arrow-return-left />
          </a>
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-12 pl-4 pr-4">
        <div class="row">
          <fast-cria-documentos :id_pessoa="fastTesourariaRenegociacao.dadosPessoa.id_pessoa"
            :id_plataforma="parseInt($route.params.id_plataforma)" :id_invoice="dados_renegociacao.id_invoice" />
        </div>
      </div>
    </modal>

    <modal name="modalVisualizarContrato" :scrollable="true" height="auto" :shift-y="0.1" :focus-trap="true"
      :adaptive="true" :width="modalWidthLg">
      <div class="row p-4">
        <div class="col-9 pl-4 pr-4">
          <h4>Gerar contrato de renegociação</h4>
        </div>
        <div class="col-3 pl-4 pr-4 text-right">
          <a class="btn btn-secondary" href="#" @click.prevent="hideModal('modalVisualizarContrato')">
            <b-icon-arrow-return-left />
          </a>
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-12 pl-4 pr-4">
        <div class="row">
          <fast-consulta-documentos-assinatura :id_plataforma="parseInt($route.params.id_plataforma)"
            :id_invoice="parseInt(dados_renegociacao.id_invoice)"
            :id_assinatura_plataforma_documento_renegociacao="dados_renegociacao.id_assinatura_plataforma_documento_renegociacao ? dados_renegociacao.id_assinatura_plataforma_documento_renegociacao : fastTesourariaRenegociacao.dadosRenegociacao.invoice_original ? fastTesourariaRenegociacao.dadosRenegociacao.invoice_original.Id_assinatura_plataforma_documento_renegociacao : undefined" />
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { settings } from "@/config";
import methods from "@/methods";
import FastCriaDocumentos from "../components/FastCriaDocumentos";
import FastConsultaDocumentosAssinatura from "../components/FastConsultaDocumentosAssinatura";

export default {
  name: "RenegociacaoRealizada",
  components: {
    FastCriaDocumentos,
    FastConsultaDocumentosAssinatura,
  },
  props: {
    dados_renegociacao: {
      type: Object,
      required: true,
    },
  },
  mixins: [methods],
  data: function () {
    return {
      modalWidthSm: this.isMobile() ? "80%" : "30%",
      modalWidthMd: this.isMobile() ? "90%" : "50%",
      modalWidthLg: this.isMobile() ? "100%" : "90%",
      fastRenegociacaoLoading: true,
      fastTesourariaRenegociacao: {
        dadosRenegociacao: {},
        dadosPessoa: {},
        parcelaRenegociacao: {
          parcelaSelecionada: {},
          dataSelecionada: "",
          formaPgtoSelecionada: "",
          parcelasRenegociadas: [],
        },
        simulacaoRealizada: [],
        usuarioGerou: "",
        listaContasReceber: [],
        statusDocumentos: {
          pagamento: {
            pathComprovante: "",
            statusComprovante: false,
          },
          contrato: {
            gerado: false,
            assinado: false,
          },
        },
      },
      // Upload arquivo
      optionsArquivo: {
        target:
          settings.endApiFastEad +
          "api/fast_tesouraria_invoice_parcela/atualiza_comprovante",
        testChunks: false,
        chunkSize: 1024 * 1024 * 100, // 100MB
        singleFile: true,
        query: {
          id_plataforma: this.$route.params.id_plataforma,
          id_invoice: 0,
          parcela: 1,
        },
        method: "POST",
        headers: { Authorization: "Bearer " + this.retornaToken() },
        categoryMap: {
          document: ["pdf", "gif", "jpg", "jpeg", "png"],
        },
        parseTimeRemaining: function (timeRemaining, parsedTimeRemaining) {
          return parsedTimeRemaining
            .replace(/\syears?/, " anos")
            .replace(/\days?/, " dias")
            .replace(/\shours?/, " horas")
            .replace(/\sminutes?/, " minutos")
            .replace(/\sseconds?/, " segundos");
        },
      },
      restrictArquivo: {
        accept: "application/pdf,image/*",
      },
      statusText: {
        success: "Sucesso",
        error: "Erro",
        uploading: "Fazendo upload...",
        paused: "Upload pausado",
        waiting: "Aguardando...",
      },
    };
  },
  mounted() {
    this.fastRenegociacaoLoading = false
    this.processaRenegociacao()
    this.getParcelamento()
  },
  watch: {
    "$store.state.fastControlaComponentes.showHideConsultaDocumentoAuteticacao"(
      newVal
    ) {
      if (newVal) {
        this.finalizaGerarDocumento();
      }
    },
    "$store.state.fastControlaComponentes.alteraNavegacaoFinalizaExclusaoDocumento"(
      newVal
    ) {
      if (newVal) {
        this.finalizaExcluirDocumento();
      }
    },
  },
  methods: {
    async processaRenegociacao() {
      let comprovante = this.dados_renegociacao.path_comprovante_pagamento;
      if (this.dados_renegociacao.id_assinatura_plataforma_documento_renegociacao) {
        this.fastTesourariaRenegociacao.statusDocumentos.contrato.gerado = true;
      }
      await this.getUsuarioGerou(this.dados_renegociacao.id_usuario_gerou);
      if (this.dados_renegociacao.id_assinatura_plataforma_documento_renegociacao)
        await this.getDocumentoAssinaturaInfo();
      if (comprovante) {
        this.fastTesourariaRenegociacao.statusDocumentos.pagamento.statusComprovante = true;
      }
      this.exibeToasty("Dados carregados", "success");
    },
    async getUsuarioGerou(id_user_gerou) {
      this.fastRenegociacaoLoading = true;
      try {
        await this.promiseGetFastApi(
          "api/fast_plataforma_usuario/lista",
          `id_plataforma=${this.dados_renegociacao.id_plataforma}&id_usuario=${id_user_gerou}`
        ).then((res) => {
          if (res.success === false || res.error) {
            this.apiCallErrorHandler(res);
          } else {
            this.fastTesourariaRenegociacao.usuarioGerou = `${res[0].nome_razao ?? ""
              } ${res[0].sobrenome_fantasia ?? ""}`;
          }
        });
        this.fastRenegociacaoLoading = false;
      } catch (error) {
        console.error(error);
        this.exibeToasty("Ocorreu um erro", "error");
        this.fastRenegociacaoLoading = false;
      }
    },
    async getParcelamento() {
      this.fastRenegociacaoLoading = true;
      try {
        await this.promiseGetFastApi(
          "api/fast_tesouraria_invoice_parcela/lista",
          `id_invoice=${this.dados_renegociacao.id_invoice}`
        ).then((res) => {
          if (res.success === false) {
            this.apiCallErrorHandler(res);
          } else {
            this.fastTesourariaRenegociacao.parcelaRenegociacao.parcelasRenegociadas =
              res;
          }
        });
        this.fastRenegociacaoLoading = false;
      } catch (error) {
        console.error(error);
        this.exibeToasty("Ocorreu um erro", "error");
        this.fastRenegociacaoLoading = false;
      }
    },
    fileValidation(id_invoice, parcela) {
      this.optionsArquivo.query.id_invoice = id_invoice;
      this.optionsArquivo.query.parcela = parcela;
    },
    fileSuccess(rootFile, file, message, chunk) {
      let result = JSON.parse(JSON.parse(message));
      if (!result.error) {
        console.log(result);
        this.fastTesourariaRenegociacao.statusDocumentos.pagamento.pathComprovante =
          result.url;
        this.fastTesourariaRenegociacao.statusDocumentos.pagamento.statusComprovante = true;
        this.exibeToasty("Comprovante salvo com sucesso", "success");
        this.hideModal("modalEnviarComprovante");
      } else {
        this.exibeToasty(result.error, "error");
      }
    },
    async buscaInvoice() {
      try {
        await this.promiseGetFastApi("api/fast_tesouraria_invoice_parcela/lista_contas_receber", `IdPlataforma=${Number(this.dados_renegociacao.id_plataforma)}&IdInvoice=${this.dados_renegociacao.id_invoice}`)
          .then(res => {
            if (res) {
              this.dados_renegociacao.id_assinatura_plataforma_documento_renegociacao = res[0].id_assinatura_plataforma_documento_renegociacao
            }
          }).catch(e => {
            console.log(e)
            this.exibeToasty(e, "error")
          })
      } catch (error) {
        console.log(error)
        this.exibeToasty(error, "error")
      }
    },
    async finalizaGerarDocumento() {
      this.buscaInvoice()
      this.hideModal("modalGerarContrato");
      this.fastTesourariaRenegociacao.statusDocumentos.contrato.gerado = true;
      this.$store.state.fastControlaComponentes.showHideConsultaDocumentoAuteticacao = false;
    },
    finalizaExcluirDocumento() {
      this.hideModal("modalVisualizarContrato");
      this.fastTesourariaRenegociacao.statusDocumentos.contrato.gerado = false;
      this.fastTesourariaRenegociacao.statusDocumentos.contrato.assinado = false;
      this.$store.state.fastControlaComponentes.alteraNavegacaoFinalizaExclusaoDocumento = false;
    },
    async getDocumentoAssinaturaInfo() {
      this.fastRenegociacaoLoading = true;
      try {
        await this.promiseGetFastApi(
          "api/fast_assinatura_plataforma_documento/lista_id",
          `id_plataforma=${this.$route.params.id_plataforma}&id_assinatura_plataforma_documento=${this.dados_renegociacao.id_assinatura_plataforma_documento_renegociacao}`
        )
          .then((res) => {
            if (res.success == false) {
              this.apiCallErrorHandler(res);
            } else if (res) {
              res.assinado
                ? (this.fastTesourariaRenegociacao.statusDocumentos.contrato.assinado = true)
                : (this.fastTesourariaRenegociacao.statusDocumentos.contrato.assinado = false);
            }
            this.fastRenegociacaoLoading = false;
          })
          .catch((e) => {
            this.exibeToasty(e, "error");
            console.log(e);
            this.fastRenegociacaoLoading = false;
          });
      } catch (error) {
        this.exibeToasty(error, "error");
        console.log(error);
        this.fastRenegociacaoLoading = false;
      }
    },
  },
};
</script>

<style>
.steps-guide-active,
.steps-guide {
  box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.2);
}

.steps-guide-active,
.steps-guide {
  border: none;
  padding: 1em 3em;
  border-radius: 16px;
  transition: 0.5s;
  color: #fff;
  font-weight: 600;
  min-height: 7em;
  align-content: center;
}

.steps-guide {
  background-color: #e66e10;
}

.steps-guide-active {
  background-color: #015b97;
}

.steps-guide-disabled {
  background-color: #aaaaaa;
}

.steps-header button:disabled {
  background-color: #dadada;
}

.steps-icon {
  color: #e66e10;
  font-size: 3em;
}

.form-check-input {
  position: relative;
}

.blink_me {
  animation: destacaBotao 500ms alternate infinite ease-in;
}

.vm--modal {
  overflow: scroll;
  min-height: 90svh;
}

@keyframes destacaBotao {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(1.1);
  }
}
</style>
